
// => Styling
import styles from './Countdown.module.css';


// ============
// Component
// ============
const Countdown = ({ time = null }) => {

    const timeFormat = {
        maximumFractionDigits: 0,
        minimumFractionDigits: 0,
        minimumIntegerDigits: 1
    }


    // RENDER
    // ---------
    return(
        time !== null && 
        (<div className={styles.container}>
            {time?.toLocaleString("en-US", timeFormat) || 0}
        </div>)
    )
}


export default Countdown